import {
  CLIENT_LOGIN_SUCCES,
  CLIENT_LOGIN_ECHEC,
  CLIENT_LOGIN_REQUETTE,
  CLIENT_LOGOUT,
  CLIENT_LISTE_SUCCES,
  CLIENT_LISTE_ECHEC,
  CLIENT_CODE_SUCCES,
  CLIENT_CODE_ECHEC,
  CLIENT_CREE_REQUETTE,
  CLIENT_CREE_SUCCES,
  CLIENT_CREE_ECHEC,
  CLIENT_CODE_REQUETTE,
  CLIENT_SERV,
} from "../constantes/clientsConstantes";
import axios from "axios";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;
//const uri = `https://ecreal.herokuapp.com`;
//const uri = `https://ecreal.onrender.com`;
//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `http://ahmed.prod-manager.tk:5000`;
//const uri = `https://gestpro.globalsystempro.com/back`;

//const uri = `http://192.168.1.21:5000`;

import { store } from "../store";

let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ.length != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();

//
export const loginClient = (nom_cli, cod_cli, rester) => async (dispatch) => {
  dispatch({ type: CLIENT_LOGIN_REQUETTE });
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };

    const { data } = await axios.post(
      `${uri}/api/client/login`,
      { cod_cli, nom_cli },
      config
    );
    data.persist = rester;
    dispatch({ type: CLIENT_LOGIN_SUCCES, payload: data });
  } catch (error) {
    console.log(error.message);
    dispatch({
      type: CLIENT_LOGIN_ECHEC,
      payload: error,
    });
    //console.log(error.response);
  }
};
const removeItemValue = async (key) => {
  try {
    return true;
  } catch (exception) {
    console.log(exception);
    return false;
  }
};
export const logout = () => async (dispatch) => {
  await removeItemValue("client");

  dispatch({ type: CLIENT_LOGOUT });
};
export const listeClients = () => async (dispatch, getState) => {
  try {
    const {
      client: { client },
    } = getState();
    const config = {
      headers: {
        authorization: `Bearer ${client.token}`,
      },
    };
    const { data } = await axios.get(`${uri}/api/client`, config);
    console.log(data);
    dispatch({ type: CLIENT_LISTE_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: CLIENT_LISTE_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};

export const clientParCode = (code_cli) => async (dispatch) => {
  try {
    dispatch({ type: CLIENT_CODE_REQUETTE });

    const { data } = await axios.get(`${uri}/api/client/${code_cli}`);

    dispatch({ type: CLIENT_CODE_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: CLIENT_CODE_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};

export const updateclientParCode = (code_cli) => async (dispatch) => {
  try {
    dispatch({ type: CLIENT_CODE_REQUETTE });

    // on utilise une requete de type put car le routes est de type mise a jour des données
    //regle general le type de requete dans l'action est toujour le meme que le type routes
    //le requete est definie par deux argumants sont : le type(GET,POST,PUT,DELETE) et l'adresse.
    const { data } = await axios.put(`${uri}/api/client/majcli/${code_cli}`);

    dispatch({ type: CLIENT_CODE_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: CLIENT_CODE_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};

export const clientInscription =
  ({
    nom_cli,
    cod_cli,
    tel_cli,
    adr_cli,
    cod_tarif,
    cod_rep,
    is_Rep,
    nivcli_cloud,
    abrv_cli,
  }) =>
  async (dispatch) => {
    try {
      // dispatch({ type: CLIENT_CREE_REQUETTE });

      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${uri}/api/demNvClient`,
        {
          nom_cli,
          cod_cli,
          tel_cli,
          adr_cli,
          cod_tarif,
          cod_rep,
          is_Rep,
          nivcli_cloud,
          abrv_cli,
        },
        config
      );

      dispatch({ type: CLIENT_CREE_SUCCES, payload: data });
    } catch (error) {
      dispatch({
        type: CLIENT_CREE_ECHEC,
        payload: error.response && error.response.data.message,
      });
      console.log(error.response);
    }
  };

export const saveClientServ = (cliServ) => async (dispatch) => {
  dispatch({ type: CLIENT_SERV, payload: cliServ });
};
